/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_ContinueInputs */

const en_directory_submit_check_continue = /** @type {(inputs: Directory_Submit_Check_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const zh_directory_submit_check_continue = /** @type {(inputs: Directory_Submit_Check_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Directory_Submit_Check_ContinueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_continue = /** @type {((inputs?: Directory_Submit_Check_ContinueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_ContinueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_continue(inputs)
	return zh_directory_submit_check_continue(inputs)
});
export { directory_submit_check_continue as "directory.submit.check.continue" }